import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Hero({ section }) {
  const { eyebrow, heading, paragraphs = [], image, ctas = [] } = section;
  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        {image && <img src={image} alt="" className="h-full w-full object-cover" />}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(105deg, rgba(16,29,54,0.94) 0%, rgba(16,29,54,0.88) 60%, rgba(16,29,54,0.72) 100%)",
          }}
        />
      </div>
      <div className="container-mist relative pt-40 pb-32 md:py-48 lg:py-56 text-white">
        <div className="max-w-[720px]">
          {eyebrow && <div className="eyebrow mb-5">{eyebrow}</div>}
          {heading && (
            <h1 className="font-display font-extrabold text-4xl sm:text-5xl leading-[1.02] tracking-[-0.03em]" style={{ fontSize: "clamp(2.5rem, 5.5vw, 6.5rem)" }}>
              {renderHeadingWithBreak(heading)}
            </h1>
          )}
          {paragraphs[0] && (
            <p className="mt-8 text-lg text-white/85 max-w-[540px] leading-relaxed">{paragraphs[0]}</p>
          )}
          {paragraphs[1] && (
            <p className="mt-3 text-[15px] text-white/60 max-w-[540px] leading-relaxed">{paragraphs[1]}</p>
          )}
          {ctas.length > 0 && (
            <div className="mt-10 flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-6">
              {ctas.map((c, i) => {
                const isPrimary = i === 0;
                return isPrimary ? (
                  <Link
                    key={c.href + c.label}
                    to={c.href}
                    data-testid={c.testid || `hero-cta-${i}`}
                    className="inline-flex items-center justify-center gap-2 px-8 h-12 text-[11px] uppercase tracking-[0.22em] font-semibold rounded-md bg-mist-gold text-mist-navy hover:bg-[#b8994f] transition-all duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mist-gold focus-visible:ring-offset-2 focus-visible:ring-offset-mist-navy"
                  >
                    {c.label}
                    <ArrowRight className="h-4 w-4" aria-hidden />
                  </Link>
                ) : (
                  <Link
                    key={c.href + c.label}
                    to={c.href}
                    data-testid={c.testid || `hero-cta-${i}`}
                    className="group inline-flex items-center gap-2 text-[13px] tracking-[0.02em] font-medium text-white/90 hover:text-white transition-colors duration-200"
                  >
                    {c.label}
                    <span aria-hidden className="inline-block transition-transform duration-200 group-hover:translate-x-1">→</span>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

/** Splits the heading on the last period ". " so the second sentence wraps in gold, matching the reference. */
function renderHeadingWithBreak(heading) {
  const idx = heading.indexOf(". ");
  if (idx === -1) return heading;
  const first = heading.slice(0, idx + 1);
  const second = heading.slice(idx + 2);
  return (
    <>
      {first}
      {/* space + <br> so textContent reads "Quality Assured. Logistics Simplified." with a space */}
      {" "}
      <br />
      <span className="text-mist-gold">{second}</span>
    </>
  );
}
